<div [formGroup]="countryForm">
  <ng-container *ngIf="!hideLabel">
    <label *scText="formFields.fields.intCountry.label"></label>
  </ng-container>
  <mat-form-field
    class="d-block ab-select form-control-custom"
    [floatLabel]="'never'"
    hideRequiredMarker
  >
    <mat-select
      [placeholder]="formFields.fields.intCountry.placeholder"
      formControlName="country"
      disableOptionCentering
      panelClass="country-list-panel"
      (blur)="(onTouched)"
      (openedChange)="onOpenedChange($event)"
    >
      <mat-select-trigger>{{
        country.value ? country.value.countryName : ''
      }}</mat-select-trigger>
      <ng-container *ngFor="let country of countryListDropDown">
        <mat-option [value]="country" [hidden]="country.hidden" *ngIf="country">
          <div class="d-flex align-items-center">
            <div class="country-list-flag">
              <span
                class="flag-icon flag-icon-{{
                  country.countryCode
                }} flag-icon-squared"
              ></span>
            </div>
            <div class="flex-grow-1 pl-1">{{ country.countryName }}</div>
            <div class="country-code" [innerHtml]="country.countryCode"></div>
          </div>
        </mat-option>
      </ng-container>
      <div class="other-container" (click)="openDialog()">
        <span class="icon-more"></span>
        <span *scText="formFields.fields.intCountry.otherCountry"></span>
      </div>
    </mat-select>
  </mat-form-field>
</div>
